export const SETTINGS_PUSH_NOTIFICATION_CLICK = "Settings_Push_Notification_Click";
export const SETTINGS_VIDEO_QUALITY_CLICK = "Settings_Video_Quality_Click";
export const SETTINGS_LANGUAGE_PREFERENCES_CLICK = "Settings_Language_Preferences_Click";
export const SETTINGS_BACK_CLICK = "Settings_Back_Click";
export const SETTINGS_LANGUAGE_PREFERENCES_OPTION_CLICK ="Settings_Language_Preferences_Option_Click";
export const SETTINGS_LANGUAGE_PREFERENCES_APPLY_CLICK = "Settings_Language_Preferences_Apply_Click";
export const SETTINGS_VIDEO_QUALITY_OPTION_CLICK = "Settings_Video_Quality_Option_Click"
export const SETTINGS_CHILD_MODE_CLICK = "Settings_Child_Mode_Click";